<script>
  export let showAdditionalHelp = true;
</script>

{#if showAdditionalHelp}
  <div class="p-2 text-xs text-gray-400">
    <slot />
  </div>
{/if}
